import { Validators } from '@angular/forms';

export const rutValidator = Validators.pattern(
  /^\d{1,2}\.\d{3}\.\d{3}-[\d|kK]$/,
);
